import get from "lodash/get"
import {
  setCustomerLob,
  clearProductUrlState,
  getLiveChat,
  setGuidedFlowSelections,
  getContactBackAttributes,
  getCityEligibility,
  getGuestContainerRepairEligibility,
} from "actions-lib"
import { fetchDataLocalsite } from "actions-lib/getLocalSitesCdn"
import { resetContainerRepair } from "actions-lib/getGuestContainerRepairEligibility"
import { updateCurrentNeighborhood } from "actions-lib/updateCurrentNeighborhood"
import { getCityBilledBulkEligibility } from "actions-lib/getCityBilledEligibility"
import { connect } from "react-redux"
import { withSpacing } from "hoc-lib/spacing"
import withSSRModel from "hoc-lib/ssrModelMapper"
import withRouter from "hoc-lib/router"
import { isBrokerAccountSelector } from "selectors-lib/linkedAccounts"
import FeaturedContentCards from "./FeaturedContentCards"

export const mapDispatchToProps = {
  getGuestContainerRepairEligibility,
  clearProductUrlState,
  getCityEligibility,
  getLiveChat,
  fetchDataLocalsite,
  updateCurrentNeighborhood,
  getCityBilledBulkEligibility,
  setCustomerLob,
  setGuidedFlowSelections,
  getContactBackAttributes,
  resetContainerRepair,
}

export const mapStateToProps = (state) => ({
  customerSelections: state.customerSelections,
  customerSupportContact: state.customerSupportContact,
  siteLanguage: state.siteLanguage,
  onlineProducts: state.onlineProducts,
  userManageAccount: state.userManageAccount,
  myServices: state.myServices,
  userState: state.userAccount.userState,
  isBrokerAccount: isBrokerAccountSelector(state),
  myWmMenuHeading: get(state.aemData, `standardnavigation.myWmMenuHeading`, ``),
  loginEmailPlaceholderText: get(
    state.aemData,
    `standardnavigation.loginEmailPlaceholderText`,
    ``,
  ),
  loginPasswordPlaceholderText: get(
    state.aemData,
    `standardnavigation.loginPasswordPlaceholderText`,
    ``,
  ),
  loginButtonCta: get(state.aemData, `standardnavigation.loginButtonCta`, ``),
  forgotEmailPwText: get(
    state.aemData,
    `standardnavigation.forgotEmailPwText`,
    ``,
  ),
  continueAsGuestText: get(
    state.aemData,
    `standardnavigation.continueAsGuestText`,
    ``,
  ),
  createProfileText: get(
    state.aemData,
    `standardnavigation.createProfileText`,
    ``,
  ),
  logoutCtaText: get(state.aemData, `standardnavigation.logoutCtaText`, ``),
  myWmDropdownLabel: get(
    state.aemData,
    `standardnavigation.myWmDropdownLabel`,
    ``,
  ),
  userAccount: state.userAccount,
})

export const ConnectedFeaturedContentCards = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FeaturedContentCards)

const WrappedComponent = withSSRModel(
  withRouter(
    withSpacing({ useRebrandedspacingColor: true })(
      ConnectedFeaturedContentCards,
    ),
  ),
)

// Component has to be mapped by the consumer
// Config has to be imported from constants-lib and passed to the MapTo function by the consumer
export default WrappedComponent
